import { useEffect } from 'react';

import {
  HOTEL_SAVED_CARD_RETURN_CHANNEL,
  isHotelSavedCardsChange,
} from './savedCardReturn';

export function useHotelSavedCardRefresh(
  enabled: boolean,
  refetch: () => Promise<unknown>,
) {
  useEffect(() => {
    if (!enabled) return;
    let refreshing = false;
    const refresh = () => {
      if (refreshing) return;
      refreshing = true;
      void refetch()
        .catch(() => {})
        .finally(() => {
          refreshing = false;
        });
    };
    // Refresh only after a card change in another portal tab or legacy return.
    // Window/iframe focus must not replace the checkout's card section.
    const channel =
      typeof BroadcastChannel === 'undefined'
        ? null
        : new BroadcastChannel(HOTEL_SAVED_CARD_RETURN_CHANNEL);
    const onReturn = (event: MessageEvent) => {
      if (isHotelSavedCardsChange(event.data)) refresh();
    };
    channel?.addEventListener('message', onReturn);
    return () => {
      channel?.close();
    };
  }, [enabled, refetch]);
}
